module.exports = __webpack_public_path__ + "img/rule-zh.73c0d95d.png";